
import React, { useState } from 'react'
import config from '../../config'

import './UserAvatar.scss'

type Props = {
    user: any
    size?: 'xs' | 'md' | 'sm' | 'lg'
}

const UserAvatar = (props: Props) => {

    const [failedAvatar, setFailedAvatar] = useState('')

    if (!props.user || !props.user.name || !props.user.surname) {

        return null
    }

    const avatar = props.user.avatar || ''
    const showInitials = avatar === '' || failedAvatar === avatar

    return (
        <>
            {showInitials ? (
                <span data-testid="user-avatar-text" className={`user-avatar as-text ${props.size}`} title={`${props.user.name} ${props.user.surname}`.toUpperCase()}>
                    {props.user.name.charAt(0) + props.user.surname.charAt(0)}
                </span>
            ) : (
                <div data-testid="user-avatar-image" className={`user-avatar as-image ${props.size}`} title={`${props.user.name} ${props.user.surname}`.toUpperCase()}>
                    <img
                        src={`${config.apiHost}/${avatar}`}
                        style={{ borderRadius: '50%' }}
                        onError={() => setFailedAvatar(avatar)}
                    />
                </div>
            )}
        </>
    )
}

export default UserAvatar
